import { useMemo } from 'react';

import Character from './Character';
import { buildConfetti, Confetti, getTeamColor, getContrastText, getDanceForIndex } from './helpers';

function Trophy() {
  return (
    <svg width="88" height="100" viewBox="0 0 90 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="champTrophyGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#FFE089" />
          <stop offset="50%" stopColor="#F9C151" />
          <stop offset="100%" stopColor="#BB402A" />
        </linearGradient>
      </defs>
      <path d="M 18 28 Q 8 28 8 40 Q 8 52 20 54" stroke="url(#champTrophyGrad)" strokeWidth="4" fill="none" strokeLinecap="round" />
      <path d="M 72 28 Q 82 28 82 40 Q 82 52 70 54" stroke="url(#champTrophyGrad)" strokeWidth="4" fill="none" strokeLinecap="round" />
      <path d="M 18 20 L 72 20 L 68 58 Q 66 66 45 66 Q 24 66 22 58 Z" fill="url(#champTrophyGrad)" stroke="#8B6914" strokeWidth="1.5" />
      <rect x="16" y="16" width="58" height="8" rx="2" fill="url(#champTrophyGrad)" stroke="#8B6914" strokeWidth="1.5" />
      <rect x="40" y="66" width="10" height="12" fill="url(#champTrophyGrad)" stroke="#8B6914" strokeWidth="1.5" />
      <rect x="28" y="78" width="34" height="8" rx="2" fill="url(#champTrophyGrad)" stroke="#8B6914" strokeWidth="1.5" />
      <rect x="24" y="86" width="42" height="6" rx="1" fill="url(#champTrophyGrad)" stroke="#8B6914" strokeWidth="1.5" />
      <ellipse cx="32" cy="30" rx="5" ry="12" fill="#FFFFFF" opacity="0.5" />
    </svg>
  );
}

// Shown to the instructor and to every student on the winning team after
// Process Final Results is clicked in the championship round. Renders two
// crowned characters paired close together — flags drape outward in
// opposite hands so the team reads as bonded rather than two separate
// users.
export default function Champions({ team }) {
  const confetti = useMemo(() => buildConfetti(80), []);
  const teamColor = team ? getTeamColor(team.name) : '#F9C151';

  return (
    <>
      <Confetti pieces={confetti} />
      <div className="celebration-header">
        <div className="celebration-kicker">⭐ Grand Finals ⭐</div>
        <div style={{ display: 'inline-block', marginBottom: '16px' }}>
          <Trophy />
        </div>
        <h1 className="celebration-title">Champions!</h1>
        <div className="celebration-team-pill" style={{ background: teamColor, color: getContrastText(teamColor) }}>
          {team?.name || 'Champion Team'}
        </div>
        <div className="celebration-subtitle">The final bracket belongs to you.</div>
      </div>
      <div className="celebration-characters-grid grid-pairs">
        <div className="celebration-character-cell" style={{ animationDelay: '0.2s' }}>
          <div className="celebration-character-pair">
            <Character
              color={teamColor}
              dance={getDanceForIndex(0)}
              pose="crown"
              teamName={team?.name || ''}
              showFlag
              flagHand="left"
              size="large"
            />
            <Character
              color={teamColor}
              dance={getDanceForIndex(1)}
              pose="crown"
              teamName={team?.name || ''}
              showFlag
              flagHand="right"
              size="large"
            />
          </div>
        </div>
      </div>
    </>
  );
}
